import { render } from "./ErrorValidate.vue?vue&type=template&id=74cdd329&scoped=true"
import script from "./ErrorValidate.vue?vue&type=script&lang=js"
export * from "./ErrorValidate.vue?vue&type=script&lang=js"

import "./ErrorValidate.vue?vue&type=style&index=0&id=74cdd329&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cdd329"]])

export default __exports__